<template>
  <div class="white-label-redemption-page-loading">
    <i
      class="white-label-redemption-page--loading__spinner fa fa-spinner fa-spin fa-2x"
    />
    <p class="white-label-redemption-page-loading__message">
      {{ $t('printable.landingPage.loadingMessage') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'WhiteLabelPrintableRewardLinkRedemptionPageLoading'
}
</script>

<style lang="scss" scoped>
.white-label-redemption-page-loading {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.white-label-redemption-page-loading__message {
  font-weight: bold;
  font-size: 18px;
  margin-top: 20px;
}
</style>
